import { Link } from "react-router-dom";
import { XCircle } from "lucide-react";
import { Button } from "@/components/ui/button";

export default function PaymentCancel() {
  return (
    <div className="max-w-xl mx-auto px-6 py-24 text-center" data-testid="payment-cancel-page">
      <XCircle className="w-16 h-16 text-slate-400 mx-auto mb-5" />
      <h1 className="font-display text-3xl font-bold text-blue-950 dark:text-blue-50">Checkout cancelled</h1>
      <p className="mt-3 text-slate-600 dark:text-slate-300">No worries — your cart is still saved. You can complete your purchase whenever you're ready.</p>
      <div className="mt-7 flex gap-3 justify-center">
        <Button asChild className="bg-blue-900 hover:bg-blue-950 text-white h-12 px-7"><Link to="/store">Return to store</Link></Button>
        <Button asChild variant="outline" className="h-12 px-7"><Link to="/">Home</Link></Button>
      </div>
    </div>
  );
}
